<template>
	<el-container direction="vertical">
<div class="colhead">
			<h2 class="header_h2">订单人员管理</h2>
		</div>
		<div>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="分组人员明细" name="cusdetail">
					<cusdetail v-if="showcusdetail" :inorder="OrderEnt"></cusdetail>
				</el-tab-pane>

				<el-tab-pane label="分组人员名单导入" name="cusinput">
					<cusinput v-if="showcusinput" :inorder="OrderEnt"></cusinput>
				</el-tab-pane>
			</el-tabs>

		</div>
	</el-container>
</template>

<script>
	import cusdetail from './OrderCusDetail.vue'
	import cusinput from './OrderCusInput.vue'
	export default {
		created() {
			var ent = this.$route.query.ent;
			
			this.OrderEnt = JSON.parse(ent);
		},
		watch: {
			// 如果路由发生变化，再次执行该方法
			"$route": "initData"
		},
		components: {
			cusdetail,
			cusinput
		},
		data() {
			return {
				OrderEnt: null,
				//默认第一个选项卡
				activeName: "cusdetail",
				showcusdetail: true,
				showcusinput: false
			}
		},
		mounted() {

		},
		methods: {
			initData() {
				var ent = this.$route.query.ent;
				// alert(JSON.stringify(ent))
				this.OrderEnt = JSON.parse(ent);
				this.showcusdetail = false;
				this.showcusinput = false;
				this.$nextTick(() => {

					if (this.activeName == "cusdetail") {
						this.showcusdetail = true;
					} else {
						this.showcusinput = true;
					}
				});
			},
			handleClick() {
				if (this.activeName == "cusdetail") {
					this.showcusdetail = true;
					this.showcusinput = false;
				} else {
					this.showcusdetail = false;
					this.showcusinput = true;
				}
			}
		}

	}
</script>
